import ReportValue from "@frameworks/web/components/generic/commonTableVal";
import React from "react";
const StockYears = (props) => {
    return (React.createElement("div", { className: "displayFlex justify-end mgt-2 " },
        React.createElement("span", { className: "DMSansNormal_12_400 txt_secondary-gray text-nowrap" },
            props.stockYear && props.stockYear + "Y",
            "\u00A0",
            props.stock),
        React.createElement("span", { className: "Roboto_12_400  txt_blackOne1 mgl-5" },
            React.createElement(ReportValue, { val: props.reportVal, stream: false, onlyval: false, percentage: true }),
            React.createElement("span", null, "%"))));
};
export default StockYears;
